// src/config.js

const BACKEND_URL = 'https://ecomapi.revampbrands.com/api/v1';
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://192.168.1.4:8002/api/v1';
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ecomapi.revampbrands.com/api/v1';

export default BACKEND_URL;
